import {setItem, getItem} from '../../common/StorageUtils';
const DEFAULT_WEEKS = ['1', '2', '3', '4', '5', '6', '7'];

export default {
    storageMap: {
        filterConfig: 'filterConfig'
    },
    handleFilterConfig (filterData) {
        let {months, days, areInter, filterTypes} = filterData;
        months.forEach((item, index) => {
            item.index = index;
        });
        return {months, days, areInter, filterTypes};
    },

    async getFilterConfigStorage () {
        let storeName = this.storageMap.filterConfig;
        let data = await getItem (storeName);
        return data;
    },

    setFilterConfigStorage (filterData) {
        let renderFilterData = this.handleFilterConfig(filterData);
        let storageData = JSON.stringify(renderFilterData);
        let filterStorage = this.getFilterConfigStorage();

        // 更新storage
        if (filterStorage !== storageData) {
            // 设置缓存
            let storageName = this.storageMap.filterConfig;
            setItem(storageName, storageData)
        }
    },


    // 仅在filterConfig为缓存时使用
    getUsableFilterConfig (filterConfig) {

        let usableFilterConfig = [];
        filterConfig.months.map((item, idx) => {
            const {value} = item || {};
            if (this.usableTag(value)) {
                // 如果是缓存, 放开weeks的限制
                item.weeks = DEFAULT_WEEKS;
                usableFilterConfig.push(item);
            }
        });

        return {...filterConfig, months: usableFilterConfig};
    },

    usableTag(tag) {
        let tags = tag && tag.split(':')[0];
        let endDate = tags && tags.split('|')[1];
        let endTime = new Date(endDate);
        endTime.setHours(23, 59, 59, 999);

        if (endTime && !isNaN(endTime.getTime()) && endTime > new Date()) {
            return true;
        }

        return false;
    }
};
